import { useDealData } from "contexts/DealContext";
import Card from "components/card";
import EnhancedTable from "../summarytable/SummaryTable";

const BuildingsSummary = () => {
    const { currentGroup } = useDealData();

    return (
        <Card extra={"items-center justify-around w-full h-full p-[16px] bg-cover gap-2 flex flex-col"}>
            <h3 className="ml-6 mb-2 text-xl self-start font-bold text-gray-700 dark:text-white">Facilities Summary</h3>
            <EnhancedTable selectedGroup={currentGroup} />
        </Card>
    )
}

export default BuildingsSummary;